<template>
  <li class="list-group-item" v-on:click="openPage($event, result.number)">
    <div class="row">
      <div class="col-4 pr-0 pl-0">
        <img :alt="result.number" class="img-fluid"
             v-bind:src="'/umbraco/mdpaper/page/GetJpg?recordId=' + recordId + '&pageId=' + result.id"/>
      </div>
      <div class="col-8">
                <span v-if="result.name">
                    <span class="bold">{{ result.name }}</span><br/>
                </span> <span class="small" v-html="result.text"></span>
        <div class="absolute-bottom small">
          <b>{{ translations.page }} {{ result.number }}</b>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  emits: ["pageSelected"],
  props: {
    isMobile: Boolean,
    result: Object
  },
  computed: {
    translations() {
      return multiPaper.translations;
    },
    recordId() {
      return this.$store.state.recordId;
    }
  },
  methods: {
    openPage(e, pageNumber) {
      const event = {
        e: e,
        pageNumber: pageNumber,
        toggle: !this.isMobile
      };
      this.$emit('pageSelected', event);
    }
  }
}
</script>